import { apiRequest } from './api';
import { Category, CategoryRequest } from '../types/category';

export const categoryService = {
  // Get all categories
  getAllCategories: async (): Promise<Category[]> => {
    return await apiRequest<Category[]>('/categories');
  },

  // Get category by ID
  getCategoryById: async (id: number): Promise<Category> => {
    return await apiRequest<Category>(`/categories/${id}`);
  },

  // Create new category
  createCategory: async (category: CategoryRequest): Promise<Category> => {
    return await apiRequest<Category>('/categories/create', {
      method: 'POST',
      body: JSON.stringify(category)
    });
  },

  // Update existing category
  updateCategory: async (id: number, category: CategoryRequest): Promise<Category> => {
    return await apiRequest<Category>(`/categories/${id}`, {
      method: 'PUT',
      body: JSON.stringify(category)
    });
  },

  // Delete category
  deleteCategory: async (id: number): Promise<void> => {
    return await apiRequest<void>(`/categories/${id}`, {
      method: 'DELETE'
    });
  }
}; 